module.exports = __webpack_public_path__ + "assets/shape-rectangle.f4f09110.svg";